<template>
  <modal
    class="ui-dialog"
    :visible="isShown"
    @on-close="hide"
  >
    <div class="ui-dialog__icon">
      <f-sprite-icon :icon-link="icon" />
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <p
      v-if="title"
      class="ui-dialog__title"
      v-html="sanitize(title)"
    />
    <p
      v-if="subtitle"
      class="ui-dialog__subtitle"
      v-html="sanitize(subtitle)"
    />
    <!-- eslint-enable vue/no-v-html -->
    <ui-button
      :wide="adaptive.isMobile"
      :text="btnLabel"
      class="ui-dialog__button"
      @click="onBtnClick"
    />
  </modal>
</template>

<script>
import IconFailed from '@images/failed.multi.svg';
import IconInfo from '@images/info.multi.svg';
import IconSucceed from '@images/success.multi.svg';

import { sanitize } from '@/utils/sanitize';

export default {
  name: 'ui-dialog',
  inject: ['adaptive'],
  props: {
    isShown: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    btnLabel: {
      type: String,
      default: 'Ок',
    },
    type: {
      type: String,
      default: 'info',
      validator: (val) => ['success', 'error', 'info'].includes(val),
    },
  },
  icons: {
    IconSucceed,
    IconFailed,
    IconInfo,
  },
  setup() {
    return {
      sanitize,
    };
  },
  computed: {
    icon() {
      switch (this.type) {
        case 'success':
          return this.$options.icons.IconSucceed;
        case 'error':
          return this.$options.icons.IconFailed;
        default:
          return this.$options.icons.IconInfo;
      }
    },
  },
  methods: {
    show() {
      this.$emit('on-show');
    },
    hide() {
      this.$emit('on-hide');
    },
    onBtnClick() {
      this.$emit('on-btn-click');
    },
  },
};
</script>

<style lang="scss">
  .ui-dialog {
    text-align: center;

    &.modal {
      & > .modal-content {
        padding-top: 40px !important;
        padding-bottom: 24px !important;

        @include breakpoint("tablet") {
          padding-top: 48px !important;
          padding-bottom: 48px !important;
        }
      }
    }

    &__icon {
      display: flex;
      justify-content: center;
      margin-bottom: 16px;

      .sprite-icon {
        width: 64px !important;
        height: 64px !important;
      }
    }

    &__title {
      margin-bottom: 4px;
      font-size: 16px;
      line-height: 24px;
      font-weight: 600;

      @include breakpoint("tablet") {
        margin-bottom: 8px;
        font-size: 20px;
        line-height: 28px;
      }
    }

    &__subtitle {
      margin-bottom: 20px;
      font-size: 14px;
      line-height: 20px;

      @include breakpoint("tablet") {
        margin-bottom: 24px;
        font-size: 16px;
        line-height: 24px;
      }
    }

    &__button {
      margin: 0 auto;
    }
  }
</style>
